import {paginatedTransform, rawTransform} from 'src/services/skuit/utils'
import {Damaged, PaginatedResponse, UnitLoc} from '../../api/models'

import {API, CustomAxiosConfig} from './types'
import { ExportFilters } from '../skuit/types'
import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[]
  exportFilters?: ExportFilters 
}
export class Units {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<UnitLoc>> => {
    const response = await this.api.get('/logistics/units', config)
    return paginatedTransform(UnitLoc)(response.data)
  }

  damaged = async (
    location: string,
    product: string,
    data: any,
    config: CustomAxiosConfig = {}
  ): Promise<Damaged[]> => {
    const response = await this.api.post(`/logistics/locations/${location}/products/${product}/damage`, data, config)
    return rawTransform(Damaged)(response.data)
  }

  lost = async (
    location: string,
    product: string,
    data: any,
    config: CustomAxiosConfig = {}
  ): Promise<null> => {
    await this.api.post(`/logistics/locations/${location}/products/${product}/lost`, data, config)
    return null
  }

  export = async ({ fields, exportFilters }: ExportProps) => {
    const guid: string | undefined = exportFilters?.guid
    const params = { fields: fields.join(','), products: guid}
    const response = await this.api.axiosInstance({
      url: 'logistics/units/export',
      params,
      responseType: 'blob'
    })
    fileDownload(response.data, `units_product_${guid}.csv`) 
  }
}
